/* eslint-disable no-console */

/**
 * @description Интервал проверки.
 * @type {number}
 */
const checkUpdateIntervalMs = 1_000 * 60 * 15; // 15 minutes

/**
 * @description Идентификатор текущего релиза.
 * @type {string}
 */
const release = import.meta.env.VITE_APP_RELEASE;

/**
 * @description Плагин для обновлений.
 * @constructor
 * @type {VuePlugin}
 */
export default function Updater() {
  /**
   * @description Выполнить переход к очередной версии.
   * @returns {void}
   */
  let toNextVersion = () => {
    console.warn('updater: transit to next version is not specified');
  };

  /**
   * @description Ожидает переход к новой версии.
   * @type {boolean}
   */
  let waitingForNextVersion = false;

  /**
   * @description Разрешить преход к очередной версии.
   * @returns {void}
   */
  this.allowUpdate = () => {
    waitingForNextVersion = true;
  };

  /**
   * @description Выполнить проверку обновления.
   * @param {Window} window Текущий контекст.
   * @returns {void}
   */
  this.checkUpdateForIndex = (window) => {
    fetch('/index.html', { method: 'HEAD' })
      .then(({ headers }) => {
        const originRelease = headers.get('release-id');
        if (originRelease && release !== originRelease) {
          this.allowUpdate();
          console.log('updater: found a next version');
        } else {
          this.startCheckByTimeout(window);
          console.log('updater: check by timeout is started again');
        }
      })
      .catch(() => {
        this.startCheckByTimeout(window);
        console.log('updater: check by timeout is started after fail');
      });
  };

  /**
   * @description Запусить проверку по истечению времени.
   * @param {Window} window Текущий контекст.
   * @returns {void}
   */
  this.startCheckByTimeout = (window) => {
    window.setTimeout(() => { this.checkUpdateForIndex(window); }, checkUpdateIntervalMs);
  };

  /**
   * @inheritDoc
   */
  this.install = () => {
    if (window) {
      toNextVersion = () => { window.location.reload(); };
      this.startCheckByTimeout(window);
      console.log('updater: check by timeout is started');
    }
  };

  /**
   * @description Выполнить переход к новой версии если доступна.
   * @returns {void}
   */
  this.tryToNextVersion = () => {
    if (waitingForNextVersion) {
      toNextVersion();
    }
  };
}
